<template>
  <div class="agreement">
    <!-- 联营协议 -->
    <div class="card">
      <div class="card__head">
        <span class="card__title">联营协议</span>
        <button class="btn btn-sm btn-primary" @click="$emit('create-agreement')">新增协议</button>
      </div>
      <el-table :data="agreementList" style="width: 100%">
        <el-table-column prop="agreementNo" label="协议编号" min-width="150" />
        <el-table-column prop="brandCode" label="品牌编码" min-width="120" />
        <el-table-column label="联营开始" min-width="120">
          <template #default="{ row }">{{ dash(formatDate(row.jointStartTime)) }}</template>
        </el-table-column>
        <el-table-column label="预估结束" min-width="120">
          <template #default="{ row }">{{ dash(formatDate(row.jointEndTime)) }}</template>
        </el-table-column>
        <el-table-column prop="jointDurationDays" label="联营时长(天)" min-width="110" align="right" />
        <el-table-column label="联营类型" min-width="110">
          <template #default="{ row }">{{ formatJointType(row.jointOperationType) }}</template>
        </el-table-column>
        <el-table-column label="预估回收总额" min-width="140" align="right">
          <template #default="{ row }"><span class="num">{{ row.totalShareAmount ? '¥' + formatCurrency(row.totalShareAmount) : '—' }}</span></template>
        </el-table-column>
        <el-table-column label="投资金额" min-width="140" align="right">
          <template #default="{ row }"><span class="num">{{ row.investAmount ? '¥' + formatCurrency(row.investAmount) : '—' }}</span></template>
        </el-table-column>
        <el-table-column label="状态" width="120">
          <template #default="{ row }">
            <span class="tag" :class="statusTagClass(row.status)">{{ formatStatus(row.status) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 出资信息 -->
    <div class="card">
      <div class="card__head">
        <span class="card__title">出资信息</span>
        <button class="btn btn-sm btn-primary" @click="$emit('create-fund')">新增出资</button>
      </div>
      <el-table :data="fundList" style="width: 100%">
        <el-table-column prop="agreementNo" label="协议编号" min-width="150" />
        <el-table-column prop="tenantId" label="出资方" min-width="110" />
        <el-table-column label="出资金额" min-width="140" align="right">
          <template #default="{ row }"><span class="num">{{ row.fundAmount ? '¥' + formatCurrency(row.fundAmount) : '—' }}</span></template>
        </el-table-column>
        <el-table-column label="出资比例(%)" min-width="110" align="right">
          <template #default="{ row }"><span class="num">{{ dash(row.fundRatio) }}</span></template>
        </el-table-column>
        <el-table-column label="出资时间" min-width="120">
          <template #default="{ row }">{{ dash(formatDate(row.fundTime)) }}</template>
        </el-table-column>
        <el-table-column prop="fundAccount" label="出资账户" min-width="150" />
        <el-table-column prop="receiptAccount" label="到账账户" min-width="150" />
        <el-table-column label="银行回单" width="110" align="right">
          <template #default="{ row }">
            <button v-if="row.bankReceiptUrl" class="dt-op" @click="$emit('view-receipt', row.bankReceiptUrl)">查看回单</button>
            <span v-else class="muted">—</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 收益分配 -->
    <div class="card">
      <div class="card__head">
        <span class="card__title">收益分配</span>
        <button class="btn btn-sm btn-primary" @click="$emit('create-profit')">新增分配</button>
      </div>
      <el-table :data="profitDistributionList" style="width: 100%">
        <el-table-column prop="agreementNo" label="协议编号" min-width="150" />
        <el-table-column prop="tenant" label="收益分配对象" min-width="140" />
        <el-table-column prop="fundSerialId" label="出资流水号" min-width="150" />
        <el-table-column label="收益分享方案" min-width="140">
          <template #default="{ row }">
            <span v-if="row.profitSharingPlan" class="tag tag-info">{{ row.profitSharingPlan }}</span>
            <span v-else class="muted">—</span>
          </template>
        </el-table-column>
        <el-table-column label="优先层保底收益(%)" min-width="150" align="right">
          <template #default="{ row }"><span class="num">{{ dash(row.seniorFloorFloorIncome) }}</span></template>
        </el-table-column>
        <el-table-column label="额外收益分成(%)" min-width="150" align="right">
          <template #default="{ row }"><span class="num">{{ dash(row.additionalProfitShareRatio) }}</span></template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  formatDate, formatCurrency, formatJointType,
  formatStatus, statusTagClass, dash
} from './formatters'

export default {
  name: 'StoreAgreementTab',
  props: {
    agreementList: { type: Array, default: () => [] },
    fundList: { type: Array, default: () => [] },
    profitDistributionList: { type: Array, default: () => [] }
  },
  emits: ['create-agreement', 'create-fund', 'create-profit', 'view-receipt'],
  setup() {
    return { formatDate, formatCurrency, formatJointType, formatStatus, statusTagClass, dash }
  }
}
</script>

<style scoped>
.agreement {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  padding: 14px 16px;
}

.card__head {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.card__title {
  font-size: 14px;
  font-weight: 500;
}

.card__head .btn {
  margin-left: auto;
}

.tag {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  padding: 1px 6px;
  border-radius: var(--radius-tag);
  white-space: nowrap;
}

.tag-success { background: var(--success-bg); color: var(--success-text); }
.tag-warning { background: var(--warning-bg); color: var(--warning-text); }
.tag-danger  { background: var(--danger-bg);  color: var(--danger-text); }
.tag-info    { background: var(--info-bg);    color: var(--info-text); }
.tag-neutral { background: var(--bg-page);    color: var(--text-secondary); }

.dt-op {
  border: none;
  background: none;
  padding: 0;
  font-family: inherit;
  font-size: 12px;
  color: var(--brand-500);
  cursor: pointer;
}

.dt-op:hover {
  text-decoration: underline;
}

.btn {
  padding: 5px 12px;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-control);
  background: var(--bg-card);
  color: var(--text-secondary);
  font-family: inherit;
  font-size: 12px;
  cursor: pointer;
}

.btn:hover {
  border-color: var(--brand-500);
  color: var(--brand-500);
}

.btn-sm { padding: 4px 10px; }

.btn-primary {
  background: var(--brand-500);
  border-color: var(--brand-500);
  color: #fff;
}

.btn-primary:hover {
  background: var(--brand-600);
  border-color: var(--brand-600);
  color: #fff;
}
</style>
